module.exports = __webpack_public_path__ + "fonts/icons-zaki.1af9c26.woff";